var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentUploadB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2538 0.335938H2.74179C1.23589 0.335938 0 1.67239 0 3.34026V29.3024C0 30.9703 1.23589 32.3359 2.74179 32.3359H13.6222C13.9193 32.3359 14.2043 32.2009 14.4143 31.9682L23.6521 21.7296C23.8621 21.497 23.9756 21.1792 23.9756 20.8501V3.34028C23.9756 1.67239 22.7597 0.335938 21.2538 0.335938ZM2.23817 29.3024V3.34026C2.23817 3.04067 2.47135 2.81481 2.74179 2.81481H21.2538C21.5242 2.81481 21.7374 3.04067 21.7374 3.34026V19.0026H14.6728C13.1669 19.0026 11.9369 20.3459 11.9369 22.0138V29.8571H2.74179C2.47135 29.8571 2.23817 29.602 2.23817 29.3024ZM14.1751 28.7113V22.0138C14.1751 21.7142 14.4023 21.4815 14.6728 21.4815H20.7201L14.1751 28.7113Z",
    fill: "#47127D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadB);
export default __webpack_public_path__ + "static/media/Document Upload_B.6813778df108d574f9d023afe19e5f24.svg";
export { ForwardRef as ReactComponent };